import {
  makeAccessibleButton,
  closeAccessibility,
  observeHeaderHeight,
  modifySearchBox,
  modifyFeatureLineup,
} from './utils.js';

// =====================================================
// Header / Navigation patches
// =====================================================

function modifyBtnNavToggle() {
  const $navToggle = $('.mobile-nav-toggle');
  const $closeToggle = $('.close-mobile-menu');

  if (!$navToggle.length || $navToggle.data('patched')) return;
  $navToggle.data('patched', true);

  // Open menu → move focus inside when menu is actually open
  makeAccessibleButton($navToggle, 'Open menu', () => {
    requestAnimationFrame(() => {
      if ($('body').hasClass('mobile-menu-open') && $closeToggle.length) {
        $closeToggle.attr('tabindex', 0).trigger('focus');
      }
    });
  });

  // Close menu → return focus to toggle when menu is actually closed
  closeAccessibility($closeToggle, $navToggle);
  makeAccessibleButton($closeToggle, 'Close menu', () => {
    requestAnimationFrame(() => {
      if (!$('body').hasClass('mobile-menu-open')) {
        $closeToggle.trigger('focusReturn.close');
      }
    });
  });
}
function hideFooterNavLinkByText(text) {
  if (!text) return;
  const $links = $('.footer-navigation a');
  if (!$links.length) return;

  $links.each(function () {
    const $a = $(this);
    if ($a.text().trim() === text) {
      const $li = $a.closest('li');
      $li.hide();

      // Hide the immediate separator after the item; if none, hide the previous separator
      const $nextSep = $li.nextAll('li.footer-navigation__separator').first();
      if ($nextSep.length) {
        $nextSep.hide();
      } else {
        const $prevSep = $li.prevAll('li.footer-navigation__separator').first();
        if ($prevSep.length) $prevSep.hide();
      }
    }
  });
}

$(document).ready(() => {
  $('.generalmessage').prependTo('header');

  modifyBtnNavToggle();
  modifySearchBox();
  modifyFeatureLineup();
  hideFooterNavLinkByText('Home');
  observeHeaderHeight();
});
